import {Injectable} from '@angular/core';

import {Constants} from '../config/constants.config';
import {formatDate} from '../utilities/date.utilities';

@Injectable()
export class DateService {
    constructor(
        private readonly constants: Constants
    ) {
    }

    getDate(date: Date = new Date()): string {
        return formatDate(date, this.constants.defaultAPIDateFormat);
    }

    dayForwards(date: Date): Date {
        return new Date(date.getTime() + this.dayTimestamp);
    }

    dayBackwards(date: Date) {
        return new Date(date.getTime() - this.dayTimestamp);
    }

    private get milisecondTimestamp(): number {
        // one milisecond = one milisecond
        return 1;
    }

    private get secondTimestamp(): number {
        // one second = 1000 miliseconds
        return 1000 * this.milisecondTimestamp;
    }

    private get minuteTimestamp(): number {
        // one minute = 60 seconds
        return 60 * this.secondTimestamp;
    }

    private get hourTimestamp(): number {
        // one hour = 60 minutes
        return 60 * this.minuteTimestamp;
    }

    private get dayTimestamp(): number {
        // one day = 24 hours
        return 24 * this.hourTimestamp;
    }
}
